import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MultiFilterPipe } from "../pipes/multifilter.pipe";
import { DateFilterPipe } from "../pipes/datefilter.pipe";
import { OnlyNumber } from "../pipes/OnlyNumber";
import { OnlyTwoDecimals } from "../pipes/OnlyTwoDecimals";
import { NumberValidation } from "../pipes/NumberValidation";
import { ShowHidePasswordComponent } from "../pipes/show-hide-password/show-hide-password.component";
import { NgSelectMobileSearchableDirective } from "./directives/ng-select-mobile-searchable.directive";

@NgModule({
  declarations: [
    MultiFilterPipe,
    DateFilterPipe,
    OnlyNumber,
    OnlyTwoDecimals,
    NumberValidation,
    ShowHidePasswordComponent,
    NgSelectMobileSearchableDirective,
  ],
  imports: [CommonModule],
  exports: [
    MultiFilterPipe,
    DateFilterPipe,
    OnlyNumber,
    OnlyTwoDecimals,
    NumberValidation,
    ShowHidePasswordComponent,
    NgSelectMobileSearchableDirective,
  ],
})
export class UtilsModule { }
